export const apiRequestInitState = {
    isFetching: false,
    payload: null,
    error: null
}

export const pagerState = {
    current: 1,
    pageSize: 10
}